import React from 'react'
import State from './src/state'

export const onClientEntry = () => {
  document.getElementById('loader')!.style.display = 'flex'
}

export const onPreRouteUpdate = () => {
  document.getElementById('loader')!.style.display = 'flex'
}

export const onRouteUpdateDelayed = () => {
  document.getElementById('loader')!.style.display = 'flex'
}

export const onRouteUpdate = () => {
  document.getElementById('loader')!.style.display = 'none'
}

export const wrapPageElement = ({ element }) => {
  return <State>{element}</State>
}
